import React, { useEffect, useState } from 'react';
import testimonialCards from '../../data/testimonials.json';

const STAR_RATINGS = [1, 2, 3, 4, 5];

const OnboardingTestimonials = () => {
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(window.innerWidth <= 768 ? 1 : 2);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setPageSize(mobile ? 1 : 2);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const totalPagesForSize = Math.max(1, Math.ceil(testimonialCards.length / pageSize));
    setPageIndex(prev => (prev >= totalPagesForSize ? totalPagesForSize - 1 : prev));
  }, [pageSize]);

  const totalPages = Math.max(1, Math.ceil(testimonialCards.length / pageSize));
  const visibleTestimonials = testimonialCards.slice(pageIndex * pageSize, pageIndex * pageSize + pageSize);
  const placeholderCount = Math.max(0, pageSize - visibleTestimonials.length);

  const handleNextTestimonial = () => {
    setPageIndex(prev => (prev + 1) % totalPages);
  };

  const handlePrevTestimonial = () => {
    setPageIndex(prev => (prev - 1 + totalPages) % totalPages);
  };

  return (
    <div className="onboarding-right__carousel-area">
      <h3 className="text-center users-title mb-3 mt-3 font-weight-bold">¿Qué dicen nuestros usuarios?</h3>
      <div className="onboarding-right__carousel-track mt-3 d-flex align-items-center justify-content-between w-100">
        <button
          type="button"
          onClick={handlePrevTestimonial}
          aria-label="Testimonio anterior"
          className="onboarding-right__carousel-button"
        >
          <span className="onboarding-right__carousel-icon">‹</span>
        </button>
        <div className="onboarding-right__testimonial-viewport">
          {visibleTestimonials.map(card => (
            <article key={`testimonial-${card.name}-${card.company}`} className="onboarding-right__testimonial mx-auto">
              <div className="onboarding-right__testimonial-stars" aria-hidden="true">
                {STAR_RATINGS.map(value => (
                  <span key={`star-${card.name}-${card.company}-${value}`} role="presentation">
                    ★
                  </span>
                ))}
              </div>
              <p className="onboarding-right__testimonial-quote m-0">&ldquo;{card.quote}&rdquo;</p>
              <div className="onboarding-right__testimonial-meta mt-2">
                <p className="mb-0">{card.name}</p>
                <p className="mb-0">
                  {card.role}
                  {card.company ? `, ${card.company}` : ''}
                </p>
              </div>
            </article>
          ))}
          {Array.from({ length: placeholderCount }, (_, index) => (
            <article
              key={`placeholder-${pageIndex}-${index}`}
              className="onboarding-right__testimonial onboarding-right__testimonial-placeholder"
              aria-hidden="true"
            />
          ))}
        </div>
        <button
          type="button"
          onClick={handleNextTestimonial}
          aria-label="Testimonio siguiente"
          className="onboarding-right__carousel-button"
        >
          <span className="onboarding-right__carousel-icon">›</span>
        </button>
      </div>
    </div>
  );
};

export default OnboardingTestimonials;
